// Stable per-device UUID, persisted via kv (Capacitor Preferences on iOS,
// localStorage on web). Used to tag locally-edited settings so we can tell
// "edits from this device" apart from server state on reconnect.
import { kv } from "@/lib/native/kv";

const KEY = "roava.device_id";

let cached: string | null = null;
let inflight: Promise<string> | null = null;

export async function getDeviceId(): Promise<string> {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = (async () => {
    const existing = await kv.get(KEY);
    if (existing && existing.length >= 8) {
      cached = existing;
      return existing;
    }
    const id =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `dev-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
    await kv.set(KEY, id);
    cached = id;
    return id;
  })();
  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

/** Synchronous read after first hydrate. Returns null until getDeviceId() resolves once. */
export function getDeviceIdSync(): string | null {
  return cached;
}
